//@ts-nocheck
import React, { useState, useEffect, useRef } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Button, FormControl, TextField } from "@mui/material";
import {
  differenceInDays,
  format,
  subMonths,
  subWeeks,
  formatISO,
  set,
  parseISO,
} from "date-fns";
import { IconArrowRight, IconDate } from "../../../../icons/Icon";
import styles from "./filterdata.module.scss";
import SpecificSitesMultiSelect from "../../../../components/SpecificSitesMultiSelect";
import InfoModal from "../../../../components/commonComponent/InfoModal";
import { DatePicker } from "@mui/x-date-pickers";
import SingleSelect from "../../../../components/commonComponent/SingleSelect";
import DefineCafeModal from "../../../../components/commonComponent/DefineCafeModal";
import axiosInstance from "../../../../api/axios";
import { BASE_URL } from "../../../../constants/apiConstants";
import { setExMenuRequisitionParams } from "../../../../services/exceptionalMenuRequistionSliceParam";
import { useDispatch, useSelector } from "react-redux";
import {
  getExMenuRequisition,
  resetExMenuRequisition,
  fetchEMRRevenueInfo,
  resetState,
} from "../../../../services/exmenuprojectionslice";
import Loader from "../../../../components/loader/Loader";
import { ExceptionalMenuRequisition } from "../../../../constants/modulConstants";
import { enUS } from "date-fns/locale";
import useDebounce from "../../../../hooks/useDebounce";

interface FilterData {
  handleClick: () => void;
  handleMenuChange: (value: boolean) => void;
}

interface Site {
  siteid: string;
  sitename: string;
  sitealias: string;
}

interface GetSitesResponse {
  sites: Site[];
}

interface RequestType {
  requesttypeid: number;
  requesttypename: string;
}

interface GetRequestTypesResponse {
  requesttypelist: RequestType[];
}

const FilterData: React.FC<FilterData> = ({
  handleClick,
  handleMenuChange,
}) => {
  const [loading, setLoading] = useState(false);
  const { params } = useSelector(
    (state: RootState) => state.ExMenuRequisitionParams
  );
  const { loading: reduxLoading } = useSelector(
    (state: RootState) => state.exmenuRequisition
  );
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [selectedSiteOption, setSelectedSiteOption] = useState<string | null>(
    null
  );
  const [selectedCafeOptions, setSelectedCafeOptions] = useState<string[]>([]);
  const [requestedType, setRequestedType] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [noOfCafes, setNoOfCafes] = useState<number>(0);
  const [siteOptions, setSiteOptions] = useState<
    { id: string; label: string; value: string }[]
  >([]);
  const [cutoffTime, setCutoffTime] = useState<any>();
  const freezeTimerRef = useRef<any>(null);
  const notificationTimerRef = useRef<any>(null);
  const endTimerRef = useRef<any>(null);
  const [cafeList, setCafeList] = useState<
    { id: string; label: string; code: string }[]
  >([]);
  const [openNotificationModal, setOpenNotificationModal] = useState(false);
  const [notificationMinutes, setNotificationMinutes] = useState<number | null>(null);
  const [cutoffdateForModal, setCutoffdateForModal] = useState<string | null>(null);
  const [formattedFreeze, setFormattedFreeze] = useState<string | null>(null);
  const [openFreezeModal, setOpenFreezeModal] = useState(false);
  const [pastMonths, setPastMonths] = useState<number>(0);
  const [requestedTypeOptions, setRequestedTypeOptions] = useState<
    { id: string; label: string; value: string }[]
  >([]);
  const roleid = Number(localStorage.getItem("roleId"));
  const specialsitecafearray = [];
  const userId = localStorage.getItem("userid");

  useEffect(() => {
    const GetTimePeriod = async () => {
      try {
        const roleId = Number(localStorage.getItem("roleId"));
        const payload = {
          modulecode: ExceptionalMenuRequisition.code,
          roleid: roleId,
          sitecodelist: [""],
        };
        const response = await axiosInstance.post(
          `${BASE_URL}/api/v1/AdminConfiguration/GetTimePeriodForViewingDetails`,
          payload
        );
        if (response?.data?.data?.pastmonth !== undefined) {
          const pastMonthsValue = response?.data?.data?.pastmonth;
          setPastMonths(pastMonthsValue !== null ? pastMonthsValue : 0);
        }
      } catch (error) {
        console.error("Error fetching time period:", error);
      }
    };

    const fetchSites = async () => {
      try {
        const userId = localStorage.getItem("userid");
        if (userId) {
          const response = await axiosInstance.post<GetSitesResponse>(
            `${BASE_URL}/api/v1/Site/GetSitesWithSpecialSiteInfoAsync`,
            { userid: userId }
          );

          const formattedSites = response.data.data.sites.map((site) => ({
            id: site.siteid,
            label: `${site.sitealias} (${site.sitecode})`,
            value: site.sitealias,
            isspecialsite: site.isspecialsite,
          }));
          setSiteOptions(formattedSites);
        }
      } catch (error) {
        console.error("Error fetching site options:", error);
      }
    };
    const fetchRequestTypes = async () => {
      try {
        const roleId = localStorage.getItem("roleId");
        if (roleId) {
          const response = await axiosInstance.post<GetRequestTypesResponse>(
            `${BASE_URL}/api/v1/ExceptionalMenuRequisition/GetExceptionalMenuRequestTypeList`,
            { roleid: parseInt(roleId) }
          );
          if (response.data) {
            const formattedRequestTypes =
              response.data.data.requesttypelist.map((type) => ({
                id: type.requesttypeid.toString(),
                label: type.requesttypename,
                value: type.requesttypename,
              }));
            setRequestedTypeOptions(formattedRequestTypes);
            if (formattedRequestTypes.length === 1) {
              setRequestedType(formattedRequestTypes[0].value);
            }
          }
        }
      } catch (error) {
        console.error("Error fetching request type options:", error);
      }
    };

    GetTimePeriod();
    fetchSites();
    fetchRequestTypes();   
  }, []);

  const GetCutOffdays = async (siteValue?: string) => {
    try {     
      // prefer explicit siteValue (when provided), otherwise use selectedSiteOption
      const siteToFind = siteValue || selectedSiteOption;
      const selectedSiteForCutoff = siteOptions.find((s) => s.value === siteToFind);      
      const roleId = Number(localStorage.getItem("roleId"));
      const payload = {
        modulecode: ExceptionalMenuRequisition.code,
        roleid: roleId,
        sitecode: selectedSiteForCutoff ? selectedSiteForCutoff.id : "",
      };
      const dateSettings = await axiosInstance.post(
        `${BASE_URL}/api/v1/AdminConfiguration/GetCutOffDetails`,
        payload
      );
      setCutoffTime({
        days: dateSettings.data.data.cutoffdays || 1,
        hours: dateSettings.data.data.cutofftimehh || 0,
        minutes: dateSettings.data.data.cutofftimemm || 0,
        alertemailnotification: dateSettings.data.data.alertemailnotification || 0,
      });
    } catch (error) {
      console.error("Error fetching time period:", error);
    }
  };

  const handleSite = async (selected: string) => {
    dispatch(resetExMenuRequisition());
    setSelectedSiteOption(selected);
  // fetch cutoff details for the selected site immediately
  GetCutOffdays(selected);
    const selectedSite = siteOptions.find((site) => site.value === selected);
    if (!selectedSite) {
      console.error("Selected site not found!");
      return;
    }
    let deliveryDate = format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ssXXX");
    const payload = {
      deliverydate: deliveryDate,
      sitecode: selectedSite.id,
    };

    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/ExceptionalMenuRequisition/GetExceptionalMenuCafeList`,
        payload
      );

      const cafes = response.data.data.cafes;
      const formattedCafes = cafes.map((cafe) => ({
        id: cafe.id,
        code: cafe.cafecode,
        label: cafe.cafename,
      }));

      setCafeList(formattedCafes);
      setSelectedCafeOptions([]);
      setNoOfCafes(formattedCafes.length);
    } catch (error) {
      console.error("Error fetching cafes:", error);
      setSelectedCafeOptions([]);
      setCafeList([]);
      setNoOfCafes(0);
    }
  };

  const customEnLocale: Locale = {
    ...enUS,
    options: {
      ...enUS.options,
      weekStartsOn: 1,
    },
  };
  useEffect(() => {
    if (siteOptions.length === 1 && startDate) {
      handleSite(siteOptions[0].value);
    }
  }, [siteOptions, startDate]);

  const handleRequest = (selected: string) => {
    dispatch(resetExMenuRequisition());
    setRequestedType(selected);
  };

  const handleCafeSelection = (selected: string[]) => {
    dispatch(resetExMenuRequisition());
    setSelectedCafeOptions(selected || []);
  };

  const handleOpenCafe = async () => {
    setOpen(true);
  };
  const handleDefineCafe = async () => {
    // const userId = localStorage.getItem('userid');
    const selectedSite = siteOptions.find(
      (site) => site.value === selectedSiteOption
    );
    let deliveryDate = format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ssXXX");

    const payload = {
      cafenamelist: specialsitecafearray,
      deliverydate: deliveryDate,
      sitecode: selectedSite.id,
      userid: userId,
    };

    try {
      const response = await axiosInstance.post(
        `${BASE_URL}/api/v1/ExceptionalMenuRequisition/SaveCafeForSpecialSite`,
        payload
      );

      const cafes = response.data.data.cafes;
      const formattedCafes = cafes.map((cafe) => ({
        id: cafe.id,
        code: cafe.cafecode,
        label: cafe.cafename,
      }));
      setCafeList(formattedCafes);
      setSelectedCafeOptions([]);
      setNoOfCafes(formattedCafes.length);
    } catch (error) {
      setSelectedCafeOptions([]);
      console.error("Error saving cafes:", error);
    }
  };

  const handleSubmit = () => {
    if (
      !startDate ||
      !selectedSiteOption ||
      !requestedType ||
      selectedCafeOptions.length === 0
    ) {
      console.error("Required fields are missing");
      return;
    }   

    const selectedSite = siteOptions.find(
      (site) => site.value === selectedSiteOption
    );
    if (!selectedSite) {
      console.error("Selected site not found!");
      return;
    }

    let deliveryDate = format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ssXXX");
    const selectedCafes = selectedCafeOptions.map(
      (code) => cafeList.find((cafe) => cafe.code === code)?.label
    );

    const requestType = requestedTypeOptions.find(
      (option) => option.label === requestedType
    );

    const endtime = formatISO(
      set(startDate, {
        hours: cutoffTime?.hours || 24,
        minutes: cutoffTime?.minutes || 0,
        seconds: 0,
      })
    );
   
  // compute milliseconds until the cutoff moment and until the freeze window
  const msUntilCutoff = parseISO(endtime).getTime() - new Date().getTime();
  
  const cutoffWindowMs = (cutoffTime?.days || 0) * 24 * 60 * 60 * 1000;
  // msUntilFreeze is the time remaining until we should show the freeze warning/modal (endtime - cutoffWindowMs)
  const msUntilFreeze = msUntilCutoff - cutoffWindowMs;

    // compute the exact freeze moment (Date) for notification/modal scheduling
  const freezeTimestamp = parseISO(endtime).getTime() - cutoffWindowMs;
  const freezeDateISO = new Date(freezeTimestamp).toISOString();
  // compute milliseconds until the actual cutoff endtime; we'll base disableRequisition on this
  const msUntilEndtime = parseISO(endtime).getTime() - Date.now();
  try {
    const fmt = format(parseISO(freezeDateISO), "dd-MM-yyyy hh:mm a");
    setFormattedFreeze(fmt);
  } catch (e) {
    setFormattedFreeze(freezeDateISO);
  }
  // try {
  //   const formattedFreeze = format(parseISO(freezeDateISO), "dd-MM-yyyy hh:mm a");
    
  // } catch (e) {
  //   console.log("freezeDateISO fs01", freezeDateISO);
  // }
  // disableRequisition should only be true when the exact cutoff endtime has passed.
  // Use msUntilEndtime (time until endtime) so large cutoff windows don't disable early.
  const disableRequisition = roleid !== 1 && msUntilEndtime <= 0;

    setLoading(true);

    const payload = {
      deliverydate: deliveryDate,
      requesttype: requestedType,
      sitecode: selectedSite.id,
      sitename: selectedSite.label,
      cafecodelist: selectedCafeOptions,
      noofcafes: noOfCafes,
      cafenames: selectedCafes,
      requesttypeid: requestType.id,
      disableRequisition: disableRequisition,
      searchtext: "",
    };

    const getpayload = {
      deliverydate: deliveryDate,
      sitecode: selectedSite.id,
      cafecodelist: selectedCafeOptions,
      requesttypeid: requestType.id,
      userid: userId,
      searchtext: params?.searchtext || "",
    };

    dispatch(getExMenuRequisition(getpayload));
    setLoading(false);
    dispatch(setExMenuRequisitionParams(payload));
    // schedule a freeze update at the exact cutoff time if user stays on the page
    try {
      // clear any previous timers
      if (freezeTimerRef.current) {
        clearTimeout(freezeTimerRef.current);
        freezeTimerRef.current = null;
      }
      if (notificationTimerRef.current) {
        clearTimeout(notificationTimerRef.current);
        notificationTimerRef.current = null;
      }
      if (endTimerRef.current) {
        clearTimeout(endTimerRef.current);
        endTimerRef.current = null;
      }
      // schedule the freeze to occur at (endtime - cutoffWindowMs)
  if (msUntilFreeze > 0 && msUntilFreeze < 7 * 24 * 60 * 60 * 1000) {
        // schedule only reasonable timeouts (less than 7 days)
        freezeTimerRef.current = setTimeout(() => {          
          // If we showed a notification (alertMinutes > 0), close it and show the freeze modal.
          const alertMinutes = cutoffTime?.alertemailnotification || 0;
          if (alertMinutes > 0) {
            try {
              setOpenNotificationModal(false);
            } catch (e) {
              console.warn("Failed to close notification modal", e);
            }
            try {
              setOpenFreezeModal(true);
            } catch (e) {
              console.warn("Failed to open freeze modal", e);
            }
          } else {
            // No alert minutes configured: do a silent freeze (no modals)
           // console.log("Silent freeze: no notification minutes configured — freezing without modals.");
          }
          // NOTE: do not set disableRequisition here. The actual disable should occur
          // at the exact cutoff endtime. This timer only controls UI notifications/modals.
          // clear timers so they don't fire again after freeze
          try {
            if (notificationTimerRef.current) {
              clearTimeout(notificationTimerRef.current);
              notificationTimerRef.current = null;
            }
            if (endTimerRef.current) {
              clearTimeout(endTimerRef.current);
              endTimerRef.current = null;
            }
            if (freezeTimerRef.current) {
              clearTimeout(freezeTimerRef.current);
              freezeTimerRef.current = null;
            }
          } catch (e) {
            console.warn('Failed to clear timers after freeze', e);
          }
        }, msUntilFreeze);
        // console.log("Scheduled freeze timer (ms until freeze):", msUntilFreeze);
        // schedule notification before freeze if alert email minutes provided
        const alertMinutes = cutoffTime?.alertemailnotification || 0;
        if (alertMinutes > 0) {
          const msUntilNotification = msUntilFreeze - alertMinutes * 60 * 1000;
          if (msUntilNotification > 0 && msUntilNotification < 7 * 24 * 60 * 60 * 1000) {
            notificationTimerRef.current = setTimeout(() => {
              setNotificationMinutes(alertMinutes);
              setCutoffdateForModal(freezeDateISO);
              // ensure formattedFreeze is set for modal display
              try {
                const fmt = format(parseISO(freezeDateISO), "dd-MM-yyyy hh:mm a");
                setFormattedFreeze(fmt);
              } catch (e) {
                setFormattedFreeze(freezeDateISO);
              }
              setOpenNotificationModal(true);
            }, msUntilNotification);
          }
        }
      } else {
        // If the freeze window already started (msUntilFreeze <= 0) we may still want to
        // show the notification modal if the alert window falls between now and endtime.
        const alertMinutes = cutoffTime?.alertemailnotification || 0;
        if (alertMinutes > 0) {
          // ms until notification should be computed relative to the endtime so that the
          // notification appears alertMinutes before the actual cutoff endtime.
          const msUntilNotificationFromEnd = msUntilEndtime - alertMinutes * 60 * 1000;
          if (
            msUntilNotificationFromEnd > 0 &&
            msUntilNotificationFromEnd < 7 * 24 * 60 * 60 * 1000
          ) {
            notificationTimerRef.current = setTimeout(() => {
              setNotificationMinutes(alertMinutes);
              setCutoffdateForModal(freezeDateISO);
              try {
                const fmt = format(parseISO(freezeDateISO), "dd-MM-yyyy hh:mm a");
                setFormattedFreeze(fmt);
              } catch (e) {
                setFormattedFreeze(freezeDateISO);
              }
              setOpenNotificationModal(true);
            }, msUntilNotificationFromEnd);
          } else if (msUntilEndtime > 0 && msUntilNotificationFromEnd <= 0) {
            // We're already within the alert window; open notification immediately.
            setNotificationMinutes(alertMinutes);
            setCutoffdateForModal(freezeDateISO);
            try {
              const fmt = format(parseISO(freezeDateISO), "dd-MM-yyyy hh:mm a");
              setFormattedFreeze(fmt);
            } catch (e) {
              setFormattedFreeze(freezeDateISO);
            }
            setOpenNotificationModal(true);
          }
        }
      }
      
      // schedule an exact endtime handler to set disableRequisition at the cutoff endtime
      if (msUntilEndtime > 0 && msUntilEndtime < 7 * 24 * 60 * 60 * 1000) {
  endTimerRef.current = setTimeout(() => {
          try {
            const updatedPayload = { ...payload, disableRequisition: true };
            dispatch(setExMenuRequisitionParams(updatedPayload));
            // if a notification modal was open, close it and show the freeze modal
            try {
              if (notificationTimerRef.current || openNotificationModal) {
                setOpenNotificationModal(false);
              }
            } catch (e) {
              console.warn('Failed to close notification modal at endtime', e);
            }
            // only open freeze modal if an alert notification was configured
            const alertMinutes = cutoffTime?.alertemailnotification || 0;
            if (alertMinutes > 0) {
              try {
                setOpenFreezeModal(true);
              } catch (e) {
                console.warn('Failed to open freeze modal at endtime', e);
              }
            }
            // clear other timers after freeze
            try {
              if (notificationTimerRef.current) {
                clearTimeout(notificationTimerRef.current);
                notificationTimerRef.current = null;
              }
              if (freezeTimerRef.current) {
                clearTimeout(freezeTimerRef.current);
                freezeTimerRef.current = null;
              }
              if (endTimerRef.current) {
                clearTimeout(endTimerRef.current);
                endTimerRef.current = null;
              }
            } catch (e) {
              console.warn('Failed to clear timers at endtime', e);
            }
          } catch (err) {
            console.error("Failed to set disableRequisition at endtime:", err);
          }
        }, msUntilEndtime);
      } else if (msUntilEndtime <= 0 && roleid !== 1) {
        // endtime already passed — ensure param reflects disabled state immediately
        // but DO NOT open the freeze modal here (this avoids showing the popup on
        // page refresh/re-select). The UI should reflect the disabled state without
        // forcing a modal. Any open notification modal will be closed.
        const updatedPayload = { ...payload, disableRequisition: true };
        dispatch(setExMenuRequisitionParams(updatedPayload));
        try {
          if (notificationTimerRef.current || openNotificationModal) {
            setOpenNotificationModal(false);
          }
        } catch (e) {
          console.warn('Failed to close notification modal on immediate endtime', e);
        }
        // clear any timers so refresh/re-select doesn't re-open modals
        try {
          if (notificationTimerRef.current) {
            clearTimeout(notificationTimerRef.current);
            notificationTimerRef.current = null;
          }
          if (freezeTimerRef.current) {
            clearTimeout(freezeTimerRef.current);
            freezeTimerRef.current = null;
          }
          if (endTimerRef.current) {
            clearTimeout(endTimerRef.current);
            endTimerRef.current = null;
          }
        } catch (e) {
          console.warn('Failed to clear timers on immediate endtime', e);
        }
        // do NOT call setOpenFreezeModal(true) here to avoid a modal popup on refresh
      }
    } catch (err) {
      console.error("Error scheduling freeze timer:", err);
    }
    dispatch(
      fetchEMRRevenueInfo({
        userid: userId,
        useridvalue: 0,
        deliverydate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ssXXX"),
        sitecode: selectedSite.id,
      })
    );
    handleClick();
    // handleMenuChange(false);
  };

  const handleAddCafe = (cafeNames: string[]) => {
    specialsitecafearray.push(...cafeNames);
    handleDefineCafe();
  };
  const isButtonDisabled = () => {
    return (
      !startDate ||
      !selectedSiteOption ||
      selectedCafeOptions.length === 0 ||
      !requestedType
    );
  };

  useEffect(() => {
    if (cafeList.length === 1) {
      setSelectedCafeOptions([cafeList[0].code]);
    } else {
      setSelectedCafeOptions([]);
    }
  }, [cafeList]);

  // cleanup freeze timer when startDate changes or component unmounts
  useEffect(() => {
    return () => {
      if (freezeTimerRef.current) {
        clearTimeout(freezeTimerRef.current);
        freezeTimerRef.current = null;
      }
      if (notificationTimerRef.current) {
        clearTimeout(notificationTimerRef.current);
        notificationTimerRef.current = null;
      }
      if (endTimerRef.current) {
        clearTimeout(endTimerRef.current);
        endTimerRef.current = null;
      }
    };
  }, [startDate]);

  // ensure all timers are cleared as soon as the system-freeze modal is opened.
  // This prevents timers from persisting across unmount/re-mount and avoids
  // accidentally re-opening modals after navigation/refresh.
  useEffect(() => {
    if (openFreezeModal) {
      try {
        if (freezeTimerRef.current) {
          clearTimeout(freezeTimerRef.current);
          freezeTimerRef.current = null;
        }
        if (notificationTimerRef.current) {
          clearTimeout(notificationTimerRef.current);
          notificationTimerRef.current = null;
        }
        if (endTimerRef.current) {
          clearTimeout(endTimerRef.current);
          endTimerRef.current = null;
        }
      } catch (e) {
        console.warn('Failed to clear timers when freeze modal opened', e);
      }
    }
  }, [openFreezeModal]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={customEnLocale}
    >
      <FormControl fullWidth>
        <div
          className={`${styles.filterData} flex justify-content-between align-items-end`}
        >
          <div
            className={`${styles.leftBox} flex justify-content-between align-items-end`}
          >
            <div
              className={`date-wrap flex flex-column mr-24 ${styles.multiSelect}`}
            >
              <label className={`${styles.label}`}>
                Delivery Date <span>*</span>
              </label>
              <DatePicker
                value={startDate}
                onChange={(newValue) => {
                  dispatch(resetExMenuRequisition());
                  setStartDate(newValue);
                }}
                slotProps={{ field: { clearable: true } }}
                format="dd MMM yyyy"
                slots={{
                  openPickerIcon: IconDate,
                }}
                placeholder="Delivery Date"
                label="Delivery Date"
                minDate={
                  roleid !== 1 &&
                  (pastMonths > 0
                    ? subMonths(new Date(), pastMonths)
                    : subWeeks(new Date(), 1))
                }
              />
            </div>
            <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
              <SingleSelect
                label="Select Site"
                options={siteOptions}
                value={
                  siteOptions.length === 1
                    ? siteOptions[0].value
                    : selectedSiteOption || ""
                }
                onChange={(event) => {
                  handleSite(event.target.value as string);
                }}
                placeholder="Select Site"
                disabled={!startDate || siteOptions.length === 1}
              />
            </div>
            {siteOptions.find((site) => site.value === selectedSiteOption)
              ?.isspecialsite && (
              <div className={`input-wrap mr-24 ${styles.inputWrap}`}>
                <label className={`${styles.label}`}>
                  No. of Cafes <span>*</span>
                </label>
                <TextField
                  className="input-rows"
                  id="outlined"
                  value={noOfCafes}
                  onChange={(e) => {
                    const value = e.target.value;
                    dispatch(resetExMenuRequisition());
                    if (/^\d*$/.test(value)) {
                      setNoOfCafes(Number(value));
                    }
                  }}
                  type="text"
                  inputProps={{
                    min: 1,
                    inputMode: "numeric",
                  }}
                />
                <button className={styles.defineCafe} onClick={handleOpenCafe}>
                  Define Cafe <span className={styles.plus}>+</span>
                </button>
              </div>
            )}

            <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
              <SpecificSitesMultiSelect
                options={cafeList}
                label="Select Cafe"
                selectedValues={
                  cafeList.length === 1
                    ? [cafeList[0].code]
                    : selectedCafeOptions
                }
                onApply={handleCafeSelection}
                placeholder="Select Cafe"
                disabled={cafeList.length === 1}
                isexmenureq={true}
                noCafeCodeShow={true}
              />
            </div>
            <div className={`flex flex-column mr-24 ${styles.multiSelect}`}>
              <SingleSelect
                label="Requested Type"
                options={requestedTypeOptions}
                value={
                  requestedTypeOptions.length === 1
                    ? requestedTypeOptions[0].value
                    : requestedType || ""
                }
                onChange={(event) => {
                  handleRequest(event.target.value as string);
                }}
                placeholder="Requested Type"
                disabled={requestedTypeOptions.length === 1}
              />
            </div>
          </div>
          <Button
            onClick={handleSubmit}
            className={`primary-btn ${styles.primaryBtn}`}
            disabled={isButtonDisabled()}
          >
            Go <IconArrowRight />
          </Button>
        </div>
      </FormControl>
      {(reduxLoading || loading) && <Loader />}
      {open && (
        <DefineCafeModal
          open={open}
          handleClose={() => setOpen(false)}
          handleOk={handleAddCafe}
          title="Define Cafe"
          noOfCafes={noOfCafes}
          closeText="Cancel"
          submitText="Add"
          startDate={startDate}
          cafeList={cafeList}
        />
      )}
      {openNotificationModal && (
        <InfoModal
          open={openNotificationModal}
          handleClose={() => setOpenNotificationModal(false)}
          title="Cutoff Warning"
          description={`The cutoff time will expire in ${notificationMinutes} minutes at ${formattedFreeze || (cutoffdateForModal ? format(parseISO(cutoffdateForModal), "dd-MM-yyyy hh:mm a") : '')}. Please save your work soon.`}
          closeText="OK"
        />
      )}
      {openFreezeModal && (
        <InfoModal
          open={openFreezeModal}
          handleClose={() => setOpenFreezeModal(false)}
          title="System Frozen"
          description={`The cutoff time ${formattedFreeze || (cutoffdateForModal ? format(parseISO(cutoffdateForModal), "dd-MM-yyyy hh:mm a") : '')} has expired. The system is now frozen and no further changes can be made.`}
          closeText="OK"
        />
      )}
    </LocalizationProvider>
  );
};

export default FilterData;
